import React, { useEffect, useState } from 'react';
import '../scss/components/subscribeModal.scss';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import * as Yup from "yup";
import { Formik } from "formik";
import { mailDomainsBlacklist, fieldsFilter, hubspot_SubscribeForm_fields } from '../utils/hubspot_utils.js';


const PORTAL_ID = '7284441';
const FORM_ID = 'e75299de-0714-40ec-93eb-ca7b5a1ad09c';

const SubscribeModal = (props) => {

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);
  const [mailError, setMailError] = useState(false)

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Must be a valid email")
      // .matches(mailDomainsBlacklist, "Company Email Only")
      .required("Required")
  })

  useEffect(() => {
    if (submitted) {
      props.onSuccess()
    }
  }, [submitted])

  const successMessage = () => {
    return (
      <section className="sectionSpacing pt-0">
        <div className="mb-0">
          <div class="container" id="confirmation--message">
            <div class="row">
              <div class="col-12 my-auto text-center">
                <img className="mt-2" src="/home/successfulFormSubmission.svg" alt="The ChartHop logo"></img>
                <p class="main--text--confirmation"> Great!
                <br /> We’ll email you shortly.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  const errorMessage = () => {
    return (
      <div className="error-submitting">
        Sorry, but we had an unexpected problem submitting your request.
        Try again later, or send a note to {" "}
        <a href="mailto:hello@charthop.com">hello@charthop.com</a>.
      </div>
    )
  }


  const mailErrorMessage = () => {
    return (
      <div className="error-submitting">
        Sorry! Please use a company email. If your issue persists, send a note to {" "}
        <a href="mailto:hello@charthop.com">hello@charthop.com</a>.
      </div>
    )
  }

  const _handleSubmit = async (values) => {
    if (!mailDomainsBlacklist.test(values.email)) {
      setMailError(true)
    } else {
      setMailError(false)
    }

    const url = typeof window !== 'undefined' ? window.location.href : '';
    const pageTitle = typeof document !== 'undefined' ? document.title : '';

    values.source = props.source ? props.source : "";

    const UTMparams = JSON.parse(sessionStorage.getItem('UTMparams'));

    const fields = [
      { name: 'email', value: values.email },
    ]

    if (UTMparams && typeof UTMparams[0] === "string") {
      fields.push({ name: UTMparams[0], value: UTMparams[1] })

    } else if (UTMparams) {
      UTMparams.forEach(property => {
        fields.push({ name: property[0], value: property[1] })
      })
    }

    const context = {
      pageUri: url,
      pageName: pageTitle
    }
    const filteredFieldsArray = fieldsFilter(fields, hubspot_SubscribeForm_fields);



    try {
      // ============ Sending to Hubspot ============ //
      await axios.request({
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        url: `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_ID}`,
        data: JSON.stringify({
          fields: filteredFieldsArray,
          context: context
        })
      })
      if (!mailError) {
        setSubmitted(true)
      }

    } catch (error) {
      setError(true)
      return
    }

  }
  if (submitted && !error && !mailError) {
    return (
      successMessage()
    )
  }
  return (
    <section className="">
      <div className="mb-0">
        <div class="container subscribeModal--box">
          <p class="subscribe--box--main--text">Get exclusive access to our latest updates</p>
          <Formik
            initialValues={{ email: "" }}
            validationSchema={validationSchema}
            onSubmit={_handleSubmit}
            render={form => (
              <form
                id="subscribe-form"
                data-portal-id={PORTAL_ID}
                data-form-id={FORM_ID}
                onSubmit={form.handleSubmit}
                class="subscribe--form"
              >
                <div className="input-container">
                 <label>
                  <span hidden>email</span>
                  <input
                    id="emailshort"
                    name="email"
                    type="text"
                    className="subscribe--input--field"
                    value={form.values.email}
                    onChange={form.handleChange}
                    placeholder="Email"
                  />
                 </label>
                  {form.touched.email && form.errors.email && (
                    <div className="error-message">{form.errors.email}</div>
                  )}
                </div>
                <button type="submit" class="subscribe--button button primary">SUBSCRIBE</button>
              </form>
            )}
          />
          <div class="subscribe--disclaimer">
            <p class="subscribe--disclaimer--text">By submitting your info, you agree to opt-in to emails from ChartHop.</p>
          </div>

          {(mailError) ? mailErrorMessage() : ((error) ? errorMessage() : "")}

        </div>
      </div>
    </section>
  )
}

export default SubscribeModal;